import React from 'react';
import { FadeIn } from './FadeIn';
export function PromiseSection() {
  return <section className="bg-sage-light py-16 px-6 md:px-12 lg:px-24" data-id="element-189">
      <div className="max-w-4xl mx-auto text-center" data-id="element-190">
        <FadeIn data-id="element-191">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-dark-green mb-8 leading-tight" data-id="element-192">
            ¿Y si la solución costara menos de $15 dólares a la semana y
            estuviera en cualquier mercado de barrio?
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-193">
          <FadeIn delay={0.2} data-id="element-194">
            <p className="text-xl md:text-2xl text-text-black" data-id="element-195">
              <span className="font-bold text-sage" data-id="element-196">No</span> estamos hablando
              de una dieta restrictiva.
            </p>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-197">
            <p className="text-xl md:text-2xl text-text-black" data-id="element-198">
              <span className="font-bold text-sage" data-id="element-199">No</span> estamos hablando
              de ejercicio intenso.
            </p>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-200">
            <p className="text-xl md:text-2xl text-text-black" data-id="element-201">
              <span className="font-bold text-sage" data-id="element-202">No</span> estamos hablando
              de suplementos caros.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} data-id="element-203">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg border border-sage/20" data-id="element-204">
            <p className="text-2xl md:text-3xl font-serif font-medium text-text-black mb-8 leading-relaxed" data-id="element-205">
              Estamos hablando de{' '}
              <span className="text-gold font-bold" data-id="element-206">
                10 ingredientes específicos
              </span>
              , preparados de una manera específica, en un orden específico,
              durante <span className="text-gold font-bold" data-id="element-207">7 días</span>.
            </p>
            <p className="text-lg md:text-xl text-text-gray" data-id="element-208">
              Ingredientes que han estado en las cocinas de las abuelas por
              siglos. Pero que la ciencia funcional moderna acaba de explicar
              exactamente por qué funcionan.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}